import React, { useCallback, useEffect, useState } from "react";
import useSlideIn from "../../hooks/useSlideIn";
import AbsoluteContainer from "../containers/AbsoluteContainer";

import loadingIcon from "../../assets/icons/rolling.svg";
import errorIcon from "../../assets/icons/error.svg";
import saveIcon from "../../assets/icons/save-new.svg";

function SlidingIconButton({
  onClick,
  active,
  title,
  src,
  size,
  background,
  x = 0,
  y = 0,
}) {
  const slideIn = useSlideIn({ inX: x, inY: y, show: active });

  return (
    <img
      onClick={onClick}
      alt={title}
      src={src}
      title={title}
      style={{
        position: "absolute",
        height: size,
        background,
        cursor: "pointer",
        ...slideIn,
      }}
    />
  );
}

export default function SaveIcon({
  onSave,
  changes,
  onClose,
  size = 25,
  style,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [prevError, setPrevError] = useState(null);

  useEffect(() => {
    if (error) {
      setPrevError(error);
      setTimeout(() => setError(null), 2500);
    }
  }, [error]);

  const handleSave = useCallback(() => {
    if (onSave) {
      setLoading(true);
      onSave(({ error, cancel, success }) => {
        if (cancel) {
          console.log("cancel");
        }
        if (error) {
          setError(error);
          setLoading(false);
        }
        if (success) {
          setError(null);
          setLoading(false);
        }
      });
    }
  }, [onSave]);

  const errorSlideIn = useSlideIn({ x: 15, show: error });

  return (
    <AbsoluteContainer
      style={{
        top: 0,
        right: 0,
        height: size,
        transitionDelay: 0,
        width: size,
        overflow: "visible",
        ...style,
        color: "#000",
      }}
    >
      <SlidingIconButton
        title="Save"
        size={size * 0.75}
        active={changes && !error && !loading}
        onClick={handleSave}
        src={saveIcon}
        x={onClose ? -10 : 0}
      />
      <SlidingIconButton
        title="loading..."
        size={size * 0.75}
        active={loading}
        src={loadingIcon}
      />
      {/* {onClose ? (
        <SlidingIconButton
          onClick={onClose}
          title="close"
          background="white"
          size={size * 0.85}
          active={onClose && !loading}
          src={closeIcon}
        />
      ) : null} */}

      <span
        style={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          fontFamily: "Muli",
          right: 0,
          background: "#ff7777",
          color: "white",
          borderRadius: 15,
          padding: "3px 10px",
          paddingRight: "3px",
          width: "auto",
          height: "auto",
          transition: "opacity 500ms",
          whiteSpace: "nowrap",
          ...errorSlideIn,
        }}
      >
        {prevError}
        <img alt="error" src={errorIcon} style={{ width: 16, marginLeft: 4 }} />
      </span>
    </AbsoluteContainer>
  );
}
